module.exports = __webpack_public_path__ + "static/media/ICON_SHARE_ACTIVE.ad76bd3a.svg";